import { useState } from 'react';

import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

import { ActivityFeed } from '@modules/_shared/components/feed-v2/ActivityFeed';
import { LOT_FEED } from '@modules/listings/lotsQueries';

export const ListingFeed: React.FC<{ readOnly?: boolean }> = ({
  readOnly = false,
}) => {
  const { lotId } = useParams();
  // Use a state-backed callback ref instead of useRef so attaching the DOM
  // element re-renders ActivityFeed with a valid scrollParent. With a plain
  // useRef the first render sees `.current === null`, and when navigating
  // from a cached listing Apollo serves the feed synchronously — there's no
  // follow-up state change to re-render after the ref attaches, and Virtuoso
  // (which is gated on `scrollParent && ...`) never mounts.
  const [scrollParent, setScrollParent] = useState<HTMLDivElement | null>(null);

  if (lotId == null) {
    return null;
  }

  return (
    <Box
      ref={setScrollParent}
      sx={{
        height: '100%',
        width: '100%',
        overflowY: 'auto',
      }}
    >
      {/* ActivityFeed already insets itself horizontally on mobile
          (px: { xs: 2, md: 0 }), so only add side padding on desktop here to
          avoid doubling it up on mobile. */}
      <Box sx={{ py: 2, px: { xs: 0, md: 2 } }}>
        <ActivityFeed
          parentType="Lot"
          parentId={lotId}
          query={LOT_FEED}
          variables={{ lot_id: lotId }}
          scrollParent={scrollParent}
          disabled={readOnly}
        />
      </Box>
    </Box>
  );
};
